import { useEffect, useState } from 'react';
import { getTeachingModeDefault } from '@/services/OfferingServices';

export function useTeachingModeDefault(accessToken: string | null) {
  const [teachingMode, setTeachingMode] = useState<string>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!accessToken) return;
    setLoading(true);
    getTeachingModeDefault(accessToken)
      .then(r => setTeachingMode(r.teachingMode ?? ''))
      .catch(() => setTeachingMode(''))
      .finally(() => setLoading(false));
  }, [accessToken]);

  return { teachingMode, loading };
}
